import {
  createDirectus,
  rest,
  aggregate,
  authentication,
  readItems,
  createItem,
  updateItem,
  deleteItem,
  readItem,
} from "@directus/sdk";

const client = createDirectus(location.origin)
  .with(authentication("cookie"))
  .with(rest());

async function get(limit, offset, search, sort) {
  const totalCount = await client.request(
    aggregate("servers", {
      aggregate: { count: "*" },
    })
  );
  let obj = {
    fields: ["*"],
  };
  if (limit != null) obj.limit = limit;
  if (offset != null) obj.offset = offset;
  if (sort) obj.sort = sort;

  if (search && search.length > 0) obj.search = search;
  const data = await client.request(readItems("servers", obj));
  return { totalCount: totalCount[0].count, data };
}

async function getById(id) {
  return await client.request(
    readItem("servers", id, { fields: ["*,mailboxes.*"] })
  );
}
async function create(data) {
  return await client.request(createItem("servers", data));
}

async function updateById(id, data) {
  return await client.request(updateItem("servers", id, data));
}

async function deleteById(id) {
  return await client.request(deleteItem("servers", id));
}
export default {
  get,
  create,
  deleteById,
  getById,
  updateById,
};
